module.exports = __webpack_public_path__ + "assets/img/dailyBg.2861622a.png";